module.exports = __webpack_public_path__ + "static/media/Error404.88643967.webp";